/* ============================================================
   La Nani — ce vede Microsoft Clarity în înregistrări

   Problema: Clarity maschează implicit conținutul paginii, iar
   înregistrările ies gri. Nu se vede unde se blochează oamenii.

   Ce facem: deschidem la vedere părțile care nu conțin date personale
   — pagina de produs, coșul, formularul ca structură, sumarul comenzii,
   caruselul, butoanele. Ce a scris clientul rămâne mascat.

   ATENȚIE, și e important: NU deschidem câmpurile de nume, telefon,
   adresă și oraș. Alea sunt date personale ale clienților, iar o
   înregistrare video în care se citește numele și telefonul cuiva e o
   problemă de GDPR, nu o facilitate de analiză. Vezi unde se opresc
   oamenii, fără să le citești datele.

   Marcăm și la deschiderea formularului, nu doar la încărcarea paginii:
   formularul e injectat de EasySell mai târziu.
   ============================================================ */
(function () {
  'use strict';

  /* zone fără date personale, pe care vrem să le vedem în înregistrări */
  var DESCHIS = [
    '.ln-pdp',
    'cart-drawer',
    '.ln-cf',
    '[data-ln-carusel]',
    '[data-ln-prag]',
    '.es-modal-content',
    '.es-order_summary-group',
    '.es-cta-group',
    '.es-cart_content-group',
    '.announcement-bar'
  ];

  /* orice poate purta ce a scris clientul rămâne ascuns */
  var ASCUNS = [
    '.es-modal-content input',
    '.es-modal-content select',
    '.es-modal-content textarea',
    '.es-first_name-group',
    '.es-phone-group',
    '.es-city-group',
    '.es-address-group',
    '.es-province-group'
  ];

  function marcheaza() {
    DESCHIS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (!el.hasAttribute('data-clarity-unmask')) el.setAttribute('data-clarity-unmask', 'true');
      });
    });
    /* masca se pune DUPĂ, ca să bată deschiderea de pe părinte */
    ASCUNS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.removeAttribute('data-clarity-unmask');
        if (!el.hasAttribute('data-clarity-mask')) el.setAttribute('data-clarity-mask', 'true');
      });
    });
  }

  var inCoada = 0;
  function programeaza() {
    if (inCoada) return;
    inCoada = setTimeout(function () { inCoada = 0; marcheaza(); }, 150);
  }

  if ('MutationObserver' in window) {
    new MutationObserver(programeaza).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', marcheaza);
  } else {
    marcheaza();
  }
  window.addEventListener('load', marcheaza);
})();
